import React from 'react'
import styled from '@emotion/styled'
import {useTranslation} from 'react-i18next'
const Loading = require('images/bakkt-loading.gif')

const ProgressContainerRelative = styled.div`
	display: flex;
	padding: 12px 0;
`

const ProgressContainer = styled.div`
	z-index: 200;
	position: absolute;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`

const ProgressContainerFullScreen = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	opacity: 0.93;
	background-color: white;
`

const ProgressContentFiller = styled.div`
	flex: 1;
`

const ProgressContentImageWrapper = styled.div`
	margin: 0 auto;
	background: white;
	display: flex;
	flex-direction: column;
	align-items: center;
`

const ProgressText = styled.p`
	margin-top: 42px;
	font-style: normal;
	font-weight: bold;
	font-size: 18px;
	line-height: 23px;
	text-align: center;
`

interface Props {
	isRelativelyPositioned?: boolean
	isFullScreen?: boolean
}

interface PropsContent {
	title?: string
}
const ProgressContent = ({title}: PropsContent) => (
	<>
		<ProgressContentFiller />
		<ProgressContentImageWrapper>
			<img src={Loading} width='60' alt='loading' aria-label='Loading' />
			{!!title && <ProgressText>{title}</ProgressText>}
		</ProgressContentImageWrapper>
		<ProgressContentFiller />
	</>
)

export const Progress = ({isRelativelyPositioned, isFullScreen}: Props) => {
	const {t} = useTranslation()
	if (isFullScreen)
		return (
			<ProgressContainerFullScreen aria-hidden='false' aria-label='Loading'>
				<ProgressContent title={t('action.checkingEligibility')} />
			</ProgressContainerFullScreen>
		)
	return isRelativelyPositioned ? (
		<ProgressContainerRelative aria-hidden='false' aria-label='Loading'>
			<ProgressContent title={t('action.checkingEligibility')} />
		</ProgressContainerRelative>
	) : (
		<ProgressContainer aria-hidden='false' aria-label='Loading'>
			<ProgressContent title={t('action.checkingEligibility')} />
		</ProgressContainer>
	)
}

export default Progress
